import { Component, Input, OnInit } from '@angular/core';
import { AppService } from '@app/services';

@Component({
  selector: 'app-auth-brand-container',
  templateUrl: './auth-container-brand.component.html',
  styleUrls: ['./auth-container-brand.component.scss'],
  standalone: false
})
export class AuthContainerBrandComponent implements OnInit {
  @Input() backToRegister = false;

  constructor(public appService: AppService) {}

  ngOnInit() {}
}
